(function () {
	function initTestimonialsSlider(block) {
		if (!block || block.dataset.testimonialsInitialized === 'true') {
			return;
		}

		block.dataset.testimonialsInitialized = 'true';

		const slides = Array.from(block.querySelectorAll('[data-testimonials-slide]'));
		const prevButtons = Array.from(block.querySelectorAll('[data-testimonials-prev]'));
		const nextButtons = Array.from(block.querySelectorAll('[data-testimonials-next]'));
		const currentCounters = Array.from(block.querySelectorAll('[data-testimonials-current]'));
		const totalCounters = Array.from(block.querySelectorAll('[data-testimonials-total]'));

		if (!slides.length) {
			return;
		}

		let currentSlide = 0;

		function updateCounters() {
			currentCounters.forEach(function (counter) {
				counter.textContent = String(currentSlide + 1);
			});

			totalCounters.forEach(function (counter) {
				counter.textContent = String(slides.length);
			});
		}

		function setActiveSlide(nextIndex) {
			currentSlide = (nextIndex + slides.length) % slides.length;

			slides.forEach(function (slide, index) {
				if (index === currentSlide) {
					slide.classList.add('is-active');
				} else {
					slide.classList.remove('is-active');
				}
			});

			updateCounters();
		}

		prevButtons.forEach(function (button) {
			button.addEventListener('click', function () {
				setActiveSlide(currentSlide - 1);
			});
		});

		nextButtons.forEach(function (button) {
			button.addEventListener('click', function () {
				setActiveSlide(currentSlide + 1);
			});
		});

		setActiveSlide(0);
	}

	function initAllTestimonialsSliders() {
		const blocks = document.querySelectorAll('[data-testimonials-slider]');

		blocks.forEach(function (block) {
			initTestimonialsSlider(block);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAllTestimonialsSliders);
	} else {
		initAllTestimonialsSliders();
	}

	if (window.acf) {
		window.acf.addAction('render_block_preview/type=testimonials', function (block) {
			const blockElement = block && block[0] ? block[0].querySelector('[data-testimonials-slider]') : null;

			if (blockElement) {
				initTestimonialsSlider(blockElement);
			}
		});
	}
})();
